/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Editors_Routine_Saved_CountInputs */

const en_us2_profile_editors_routine_saved_count = /** @type {(inputs: Profile_Editors_Routine_Saved_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Routine updated: 1 day a week`);
	return /** @type {LocalizedString} */ (`Routine updated: ${i?.count} days a week`)
	
};

const pt_br2_profile_editors_routine_saved_count = /** @type {(inputs: Profile_Editors_Routine_Saved_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Rotina atualizada: 1 dia por semana`);
	return /** @type {LocalizedString} */ (`Rotina atualizada: ${i?.count} dias por semana`)
	
};

const es_419_profile_editors_routine_saved_count = /** @type {(inputs: Profile_Editors_Routine_Saved_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Rutina actualizada: 1 día por semana`);
	return /** @type {LocalizedString} */ (`Rutina actualizada: ${i?.count} días por semana`)
	
};

const pt_pt2_profile_editors_routine_saved_count = /** @type {(inputs: Profile_Editors_Routine_Saved_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Rotina atualizada: 1 dia por semana`);
	return /** @type {LocalizedString} */ (`Rotina atualizada: ${i?.count} dias por semana`)
	
};

const fr_fr2_profile_editors_routine_saved_count = /** @type {(inputs: Profile_Editors_Routine_Saved_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Rythme mis à jour : 1 jour par semaine`);
	return /** @type {LocalizedString} */ (`Rythme mis à jour : ${i?.count} jours par semaine`)
	
};

const de_de2_profile_editors_routine_saved_count = /** @type {(inputs: Profile_Editors_Routine_Saved_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Routine aktualisiert: 1 Tag pro Woche`);
	return /** @type {LocalizedString} */ (`Routine aktualisiert: ${i?.count} Tage pro Woche`)
	
};

const it_it2_profile_editors_routine_saved_count = /** @type {(inputs: Profile_Editors_Routine_Saved_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Routine aggiornata: 1 giorno a settimana`);
	return /** @type {LocalizedString} */ (`Routine aggiornata: ${i?.count} giorni a settimana`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "Routine updated: 1 day a week" |
* | * | "Routine updated: {count} days a week" |
*
* @param {Profile_Editors_Routine_Saved_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_routine_saved_count = /** @type {((inputs: Profile_Editors_Routine_Saved_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Routine_Saved_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_routine_saved_count(inputs)
	if (locale === "es-419") return es_419_profile_editors_routine_saved_count(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_routine_saved_count(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_routine_saved_count(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_routine_saved_count(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_routine_saved_count(inputs)
	return en_us2_profile_editors_routine_saved_count(inputs)
});
export { profile_editors_routine_saved_count as "profile-editors.routine_saved_count" }